import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  cartItem: Order.CartItem;
  currency: currencies.Currency;
  /**
   * Note: possibly depreciated, revisit once shipping information is finalized.
   */
  status?: Order.Status;
  shippingInfo?: ZephyrWeb.AddressInfo | null;
}


import { computed, Component } from 'vue';

import { Order } from '@models';
import { useStore } from '@store';
import * as currencies from '@utils/currencies';

import DisplayAddress from '@components/Display/DisplayAddress.vue';
import DisplayText from '@components/Display/DisplayText.vue';
import Spacer from '@components/Spacer.vue';

interface ItemDetail {
  id: string;
  label: string;
  value: unknown;
  component: Component;
}

const __default__ = { name: 'OrderCardItem' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cartItem: null,
    currency: null,
    status: null,
    shippingInfo: null
  },
  setup(__props: any) {

const props = __props as {
  cartItem: Order.CartItem;
  currency: currencies.Currency;
  /**
   * Note: possibly depreciated, revisit once shipping information is finalized.
   */
  status?: Order.Status;
  shippingInfo?: ZephyrWeb.AddressInfo | null;
};

/**
 * `OrderCardItem` component properties.
 */


const store = useStore();

const imageUrl = computed(() => {
  const thumbnail =
    props.cartItem.images?.[0] ??
    store.state.shop.products[props.cartItem.id]?.images[0];

  let value: string;

  if (thumbnail) {
    value = thumbnail.replace(/ /g, '%20');
  } else {
    value = '';
  }

  return value;
});

const displayPrice = computed(() => {
  let value: string;

  const { total, quantity } = props.cartItem;

  if (total !== 0) {
    value = currencies.format({
      amount: total / quantity, // NOTE: cart item `price` may have this value.
      currency: props.currency,
      unitType: 'smallest',
    });
  } else {
    value = 'Free';
  }

  return value;
});

const displayStatus = computed(() => {
  return props.shippingInfo ? props.status : 'Activated';
});

const itemDetails = computed(() => {
  const items: ItemDetail[] = [
    {
      id: 'quantity',
      label: 'Quantity',
      value: props.cartItem.quantity,
      component: DisplayText,
    },
    {
      id: 'price',
      label: 'Price',
      value: displayPrice.value,
      component: DisplayText,
    },
    // {
    //   id: 'status',
    //   label: 'Status',
    //   value: displayStatus,
    //   component: DisplayText,
    // },
  ];

  if (props.shippingInfo) {
    items.push({
      id: 'ship-to',
      label: 'Ship To',
      value: displayStatus,
      component: DisplayAddress,
    });
  }

  return items;
});

return { __sfc: true,props, store, imageUrl, displayPrice, displayStatus, itemDetails, Spacer }
}

})